<template>
    <filter-wrapper :filterName='settings.name' :expand='expanded'>
        <div class='filter-holder'>
            <q-select
                filled
                label="Select"
                :options="items"
                :use-input='settings.searchable'
                @filter="filter"
                :modelValue="modelValue"
                @update:modelValue="updateModelValue"
                @focus="focus=true"
                @blur="focus=false"
            >   
                <template v-slot:append>
                    <q-icon name="cancel" v-if="searchText && focus" @click.stop.prevent="searchText = ''" class="cursor-pointer"></q-icon>
                </template>
            </q-select>
        </div>
    </filter-wrapper>
</template>

<script setup>
import { ref, defineProps, defineEmits, onMounted } from 'vue'
import FilterWrapper from './FilterWrapper.vue'

const props = defineProps({
    settings: {
        type: Object,
        default: () => ({
            items: [],
        })
    },
    type: {
        type: String,
        default: 'checkbox'
    },
    modelValue: {
        type: Object
    },
    expanded: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['update:modelValue'])

let items = ref([])
const searchText = ref('')
const focus = ref(false)

onMounted(() => {
    
    setupDropdownOptions()
})

const setupDropdownOptions = () => {
    items.value.length && items.value.splice(0, items.value.length)
    props.settings.items.forEach(item => {
        const isString = typeof item === 'string'
        const label = isString ? item : item.label
        const value = isString ? item : item.value
        items.value.push({label, value})
    })
}

const filter = (val, update) => {
    if (val === '') {
        searchText.value = ''
        update(() => {
            setupDropdownOptions()
        })
        return
    }

    update(() => {
        searchText.value = val
        const needle = val.toLowerCase()
        items.value = items.value.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
    })
}

const updateModelValue = (value) => {
    emit('update:modelValue', value)
}
</script>

<style lang='scss' scoped>
    .filter-holder {
        padding: 0 12px 10px 12px;
    }
</style>